<template>
  <v-app>
    <v-dialog v-model="modalStatus" scrollable persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Historia clínica del paciente</span>
        </v-card-title>
        <v-card-text>
          <v-tabs vertical>
            <v-tab>Información de consulta</v-tab>
            <v-tab>Historia personal y social</v-tab>
            <v-tab>Alimentación diaria</v-tab>
            <v-tab>Grupo de alimentos</v-tab>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formEditPatient.name"
                        label="Nombre del paciente"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="Altura"
                        v-model="formEditPatient.height"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="Fecha"
                        type="date"
                        v-model="formEditPatient.birthday"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-select
                        label="Género"
                        v-model="formEditPatient.gender"
                        :items="['Hombre', 'Mujer']"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="Ocupación"
                        v-model="formEditPatient.occupation"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="
                          formEditPatient.clinic_history.reason_consultation
                        "
                        label="Motivo de consulta"
                        :error-messages="
                          errorsMessages['clinic_history.reason_consultation']
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formEditPatient.clinic_history.goals"
                        :error-messages="errorsMessages['clinic_history.goals']"
                        label="Metas o expectativas"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <h3>Enfermedades digestivas</h3>
                  <v-row>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        v-model="formEditPatient.clinic_history.constipation"
                        label="Estreñimiento"
                      ></v-switch>
                    </v-col>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        v-model="formEditPatient.clinic_history.diarrhea"
                        label="Diarrea"
                      ></v-switch>
                    </v-col>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        v-model="
                          formEditPatient.clinic_history.gastroesophageal_reflux
                        "
                        label="Reflujo gastroesofágico"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        v-model="formEditPatient.clinic_history.colitis"
                        label="Colitis"
                      ></v-switch>
                    </v-col>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        v-model="formEditPatient.clinic_history.diverticulitis"
                        label="Diverculitis"
                      ></v-switch>
                    </v-col>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        v-model="formEditPatient.clinic_history.gallstones"
                        label="Cálculos biliares"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        v-model="formEditPatient.clinic_history.hemorrhoids"
                        label="Hemorroides"
                      ></v-switch>
                    </v-col>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        v-model="formEditPatient.clinic_history.other_diseases"
                        label="Otro(s)"
                      ></v-switch>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-show="formEditPatient.clinic_history.other_diseases"
                        label="¿Cuáles?"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <h3>Recomendaciones</h3>
                  <v-row>
                    <v-col>
                      <v-autocomplete
                        v-model="
                          formEditPatient.clinic_history.recommendation_id
                        "
                        :items="recommendations"
                        item-value="id"
                        item-text="name"
                        :error-messages="
                          errorsMessages['clinic_history.recommendation_id']
                        "
                      />
                    </v-col>
                  </v-row>
                  <h3>Calidad del sueño</h3>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formEditPatient.clinic_history.sleep_hours"
                        label="¿Cuántas horas duerme?"
                        :error-messages="
                          errorsMessages['clinic_history.sleep_hours']
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        v-model="formEditPatient.clinic_history.hard_getting_up"
                        label="¿Le cuesta levantarse en las mañanas?"
                      ></v-switch>
                    </v-col>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        v-model="formEditPatient.clinic_history.enough_rest"
                        label="¿Siente que descansa lo suficiente?"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <h3>Actividad física</h3>
                  <v-row>
                    <v-col>
                      <v-select
                        v-model="
                          formEditPatient.clinic_history.physical_activity
                        "
                        clearable
                        :items="['Sedentario', 'Bajo', 'Moderado', 'Alto']"
                        :error-messages="
                          errorsMessages['clinic_history.physical_activity']
                        "
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formEditPatient.clinic_history.exercise_type"
                        label="Tipo de ejercicio"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        label="Fumador"
                        v-model="formEditPatient.clinic_history.smoker"
                      ></v-switch>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="Frecuencia"
                        v-show="formEditPatient.clinic_history.smoker"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        label="Bebe alcohol"
                        v-model="formEditPatient.clinic_history.drink_alcohol"
                      ></v-switch>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="Frecuencia"
                        v-show="formEditPatient.clinic_history.drink_alcohol"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        label="Alergia alimentaria"
                        v-model="formEditPatient.clinic_history.food_allergy"
                      ></v-switch>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="¿Cuáles?"
                        v-show="formEditPatient.clinic_history.food_allergy"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formEditPatient.clinic_history.consumption"
                        label="Alimentos que le gusta consumir"
                        :error-messages="
                          errorsMessages['clinic_history.consumption']
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formEditPatient.clinic_history.non_consumption"
                        label="Alimentos que no le gusta consumir"
                        :error-messages="
                          errorsMessages['clinic_history.non_consumption']
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formEditPatient.clinic_history.meals_a_day"
                        label="¿Cuántas comidas realiza al día?"
                        :error-messages="
                          errorsMessages['clinic_history.meals_a_day']
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formEditPatient.clinic_history.meals_at_home"
                        label="¿Cuántas comidas realiza en casa?"
                        :error-messages="
                          errorsMessages['clinic_history.meals_at_home']
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="
                          formEditPatient.clinic_history.meals_away_from_home
                        "
                        label="¿Cuántas comidas realiza fuera de casa?"
                        :error-messages="
                          errorsMessages['clinic_history.meals_away_from_home']
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-switch
                        :false-value="0"
                        :true-value="1"
                        v-model="
                          formEditPatient.clinic_history.food_supplements
                        "
                        label="Uso de suplementos alimenticios"
                      ></v-switch>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-show="formEditPatient.clinic_history.food_supplements"
                        v-model="formEditPatient.food_supplements_description"
                        label="¿Cuáles?"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th>Grupo de alimentos</th>
                        <th>Cantidad</th>
                        <th>Tipo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Frutas</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.fruits_quantity"
                            :error-messages="
                              errorsMessages['food_group.fruits_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.fruits_type"
                            :error-messages="
                              errorsMessages['food_group.fruits_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Verduras</th>
                        <td>
                          <v-text-field
                            v-model="
                              formEditPatient.food_group.vegetables_quantity
                            "
                            :error-messages="
                              errorsMessages['food_group.vegetables_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.vegetables_type"
                            :error-messages="
                              errorsMessages['food_group.vegetables_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Cereales</th>
                        <td>
                          <v-text-field
                            v-model="
                              formEditPatient.food_group.cereals_quantity
                            "
                            :error-messages="
                              errorsMessages['food_group.cereals_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.cereals_type"
                            :error-messages="
                              errorsMessages['food_group.cereals_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Arroz</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.rice_quantity"
                            :error-messages="
                              errorsMessages['food_group.rice_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.rice_type"
                            :error-messages="
                              errorsMessages['food_group.rice_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Tortilla</th>
                        <td>
                          <v-text-field
                            v-model="
                              formEditPatient.food_group.tortilla_quantity
                            "
                            :error-messages="
                              errorsMessages['food_group.tortilla_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.tortilla_type"
                            :error-messages="
                              errorsMessages['food_group.tortilla_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Pasta</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.pasta_quantity"
                            :error-messages="
                              errorsMessages['food_group.pasta_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.pasta_type"
                            :error-messages="
                              errorsMessages['food_group.pasta_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Pan</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.bread_quantity"
                            :error-messages="
                              errorsMessages['food_group.bread_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.bread_type"
                            :error-messages="
                              errorsMessages['food_group.bread_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Res</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.beef_quantity"
                            :error-messages="
                              errorsMessages['food_group.beef_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.beef_type"
                            :error-messages="
                              errorsMessages['food_group.beef_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Pollo</th>
                        <td>
                          <v-text-field
                            v-model="
                              formEditPatient.food_group.chicken_quantity
                            "
                            :error-messages="
                              errorsMessages['food_group.chicken_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.chicken_type"
                            :error-messages="
                              errorsMessages['food_group.chicken_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Cerdo</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.pork_quantity"
                            :error-messages="
                              errorsMessages['food_group.pork_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.pork_type"
                            :error-messages="
                              errorsMessages['food_group.pork_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Pescado</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.fish_quantity"
                            :error-messages="
                              errorsMessages['food_group.fish_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.fish_type"
                            :error-messages="
                              errorsMessages['food_group.fish_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Huevo</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.egg_quantity"
                            :error-messages="
                              errorsMessages['food_group.egg_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.egg_type"
                            :error-messages="
                              errorsMessages['food_group.egg_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Salchicha / Chorizo</th>
                        <td>
                          <v-text-field
                            v-model="
                              formEditPatient.food_group.sausage_quantity
                            "
                            :error-messages="
                              errorsMessages['food_group.sausage_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.sausage_type"
                            :error-messages="
                              errorsMessages['food_group.sausage_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Jamón</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.ham_quantity"
                            :error-messages="
                              errorsMessages['food_group.han_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.ham_type"
                            :error-messages="
                              errorsMessages['food_group.ham_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Frijol</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.bean_quantity"
                            :error-messages="
                              errorsMessages['food_group.bean_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.bean_type"
                            :error-messages="
                              errorsMessages['food_group.bean_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Lenteja</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.lentil_quantity"
                            :error-messages="
                              errorsMessages['food_group.lentil_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.lentil_type"
                            :error-messages="
                              errorsMessages['food_group.lentil_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Queso</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.cheese_quantity"
                            :error-messages="
                              errorsMessages['food_group.cheese_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.cheese_type"
                            :error-messages="
                              errorsMessages['food_group.cheese_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Leche</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.milk_quantity"
                            :error-messages="
                              errorsMessages['food_group.milk_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.milk_type"
                            :error-messages="
                              errorsMessages['food_group.milk_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Yogurt</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.yogurt_quantity"
                            :error-messages="
                              errorsMessages['food_group.yogurt_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.yogurt_type"
                            :error-messages="
                              errorsMessages['food_group.yogurt_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Café</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.coffee_quantity"
                            :error-messages="
                              errorsMessages['food_group.coffee_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.coffee_type"
                            :error-messages="
                              errorsMessages['food_group.coffee_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Refrescos</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.soda_quantity"
                            :error-messages="
                              errorsMessages['food_group.soda_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.soda_type"
                            :error-messages="
                              errorsMessages['food_group.soda_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Agua</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.water_quantity"
                            :error-messages="
                              errorsMessages['food_group.water_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.water_type"
                            :error-messages="
                              errorsMessages['food_group.water_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Agua mineral</th>
                        <td>
                          <v-text-field
                            v-model="
                              formEditPatient.food_group.mineral_water_quantity
                            "
                            :error-messages="
                              errorsMessages[
                                'food_group.mineral_water_quantity'
                              ]
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="
                              formEditPatient.food_group.mineral_water_type
                            "
                            :error-messages="
                              errorsMessages['food_group.water_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Mantequilla</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.butter_quantity"
                            :error-messages="
                              errorsMessages['food_group.butter_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.butter_type"
                            :error-messages="
                              errorsMessages['food_group.butter_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                      <tr>
                        <th>Aceite</th>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.oil_quantity"
                            :error-messages="
                              errorsMessages['food_group.oil_quantity']
                            "
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="formEditPatient.food_group.oil_type"
                            :error-messages="
                              errorsMessages['food_group.oil_type']
                            "
                          ></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="closeModal">Cerrar</v-btn>
          <v-btn color="success" @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import showValidationErrors from "../../../utils/showValidationErrors";
import ValidationError from "../../../errors/ValidationError";

export default {
  name: "ClinicHistory",
  props: ["openModal", "patient"],
  data() {
    return {
      dateModal: false,
      errorsMessages: {},
      formEditPatient: this.patient,
      modalStatus: this.openModal,
      recommendations: [],
    };
  },
  created() {
    if (!this.patient.clinic_history) {
      this.formEditPatient.clinic_history = {};
    }
    if (!this.patient.food_group) {
      this.formEditPatient.food_group = {};
    }
  },
  methods: {
    closeModal() {
      this.modalStatus = false;
      this.$emit("close-modal");
    },
    save() {
      this.openLoader();
      window.setTimeout(async () => {
        try {
          const { message } = await this.putRequest(
            `catalogs/patients/${this.formEditPatient.id}`,
            this.formEditPatient
          );
          this.showSuccessMessage(message);
          this.closeModal();
        } catch (e) {
          if (e instanceof ValidationError) {
            this.errorsMessages = e.errors;
            showValidationErrors(e.errors);
          }
        } finally {
          this.closeLoader();
        }
      }, 200);
    },
  },
  beforeMount() {
    this.openLoader();
    window.setTimeout(() => {
      const request = this.sendRequest(
        this.$store.state.apiUrl + "catalogs/recommendations"
      );
      request
        .then(({ data }) => {
          this.recommendations = data;
        })
        .finally(() => this.closeLoader());
    }, 200);
  },
};
</script>
